import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, Phone, MapPin, Instagram, Linkedin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_1ff2469a-cc07-4a64-8048-80682e85709b/artifacts/slhfghe3_OC_logo.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#050505] border-t border-[#262626]">
      {/* CTA Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-32">
        <div className="text-center">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-[#EDEDED] mb-6">
            Ready to Elevate Your Brand?
          </h2>
          <p className="text-[#A3A3A3] text-lg mb-10 max-w-2xl mx-auto">
            Let's create visuals that move your business forward.
          </p>
          <Link
            to="/contact"
            data-testid="footer-cta-button"
            className="inline-flex items-center gap-2 btn-primary text-sm uppercase tracking-wider">

            Start a Project
            <ArrowUpRight size={18} />
          </Link>
        </div>
      </div>

      {/* Footer Content */}
      <div className="border-t border-[#262626]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
            {/* Brand */}
            <div className="lg:col-span-1">
              <Link to="/" className="inline-block mb-6">
                <img
                  src={LOGO_URL}
                  alt="OBRA Creatives"
                  className="h-10 w-auto" />

              </Link>
              <p className="text-[#A3A3A3] text-sm leading-relaxed mb-6">
                Premium commercial photography and videography for businesses that demand excellence.
              </p>
              <p data-testid="footer-service-area" className="text-[#666] text-xs uppercase tracking-[0.2em] mb-6">
                Photographer &amp; Videographer · Manawatū · Palmerston North · Wellington
              </p>
              <div className="flex gap-4">
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="social-instagram"
                  className="text-[#A3A3A3] hover:text-[#D4C5B0] transition-colors"
                  aria-label="Instagram">

                  <Instagram size={20} />
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="social-linkedin"
                  className="text-[#A3A3A3] hover:text-[#D4C5B0] transition-colors"
                  aria-label="LinkedIn">

                  <Linkedin size={20} />
                </a>
              </div>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="text-[#EDEDED] font-semibold mb-6 text-sm uppercase tracking-wider">
                Navigation
              </h4>
              <nav className="flex flex-col gap-4">
                <Link to="/" className="footer-link text-sm">Home</Link>
                <Link to="/about" className="footer-link text-sm">About</Link>
                <Link to="/services" className="footer-link text-sm">Services</Link>
                <Link to="/portfolio" className="footer-link text-sm">Portfolio</Link>
                <Link to="/contact" className="footer-link text-sm">Contact</Link>
              </nav>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-[#EDEDED] font-semibold mb-6 text-sm uppercase tracking-wider">
                Services
              </h4>
              <nav className="flex flex-col gap-4">
                <Link to="/portfolio?category=Photography" className="footer-link text-sm">Photography</Link>
                <Link to="/portfolio?category=Film" className="footer-link text-sm">Videography</Link>
                <Link to="/portfolio?category=Social Media Content" className="footer-link text-sm">Social Media Content</Link>
              </nav>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-[#EDEDED] font-semibold mb-6 text-sm uppercase tracking-wider">
                Contact
              </h4>
              <div className="flex flex-col gap-4">
                <a
                  href="mailto:create@obracreatives.co.nz"
                  className="footer-link text-sm flex items-center gap-2">

                  <Mail size={16} />
                  create@obracreatives.co.nz
                </a>
                <a
                  href="tel:+6421234567"
                  className="footer-link text-sm flex items-center gap-2">
                  +64 210 2922558
                  <Phone size={16} />

                </a>
                <span className="text-[#A3A3A3] text-sm flex items-center gap-2">Manawatu, New Zealand
                  <MapPin size={16} />

                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#262626]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#A3A3A3] text-xs">
              © {currentYear} OBRA Creatives. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-[#A3A3A3] text-xs hover:text-[#EDEDED]">
                Privacy Policy
              </a>
              <a href="#" className="text-[#A3A3A3] text-xs hover:text-[#EDEDED]">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>);

}